// extracted by mini-css-extract-plugin
export var contentBody = "_dv-9";
export var headerImage = "_dv-2";
export var imageButton = "_dv-7";
export var imageButtonIcon = "_dv-8";
export var imageHeader = "_dv-4";
export var imageHeaderText = "_dv-5";
export var imageOverlay = "_dv-3";
export var imageTitle = "_dv-6";
export var imageWrapper = "_dv-1";
export var taskList = "_dv-a";
export var widget = "_dv-0";